
    import './styles.scoped.css';
    export default {
  "toggle": "awsui_toggle_1uo6m_xgokx_13",
  "drawer-triggers": "awsui_drawer-triggers_1uo6m_xgokx_19",
  "drawer": "awsui_drawer_1uo6m_xgokx_19",
  "drawer-mobile": "awsui_drawer-mobile_1uo6m_xgokx_29",
  "drawer-closed": "awsui_drawer-closed_1uo6m_xgokx_32",
  "drawer-content": "awsui_drawer-content_1uo6m_xgokx_39",
  "drawer-content-clickable": "awsui_drawer-content-clickable_1uo6m_xgokx_53",
  "drawer-resize-content": "awsui_drawer-resize-content_1uo6m_xgokx_63",
  "drawer-content-wrapper": "awsui_drawer-content-wrapper_1uo6m_xgokx_68",
  "drawer-triggers-wrapper": "awsui_drawer-triggers-wrapper_1uo6m_xgokx_72",
  "drawer-trigger": "awsui_drawer-trigger_1uo6m_xgokx_19",
  "drawer-trigger-active": "awsui_drawer-trigger-active_1uo6m_xgokx_91",
  "resize-handle-wrapper": "awsui_resize-handle-wrapper_1uo6m_xgokx_99",
  "hide": "awsui_hide_1uo6m_xgokx_109"
};
  